import { useTranslation } from "react-i18next";

import { FolderCartographieTab } from "src/brand/EC/components/folder/FolderCartographieTab";
import { FolderElements } from "src/brand/EC/components/folder/FolderElements";
import ElementsIcon from "src/core/assets/images/icons/elements.svg?react";
import ValidationIcon from "src/core/assets/images/icons/shieldOk.svg?react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "src/core/components/ui/tabs";
import { cn } from "src/core/lib/utils";

type FolderDetailsECProps = {
  isDraft: boolean;
  selectedDetailsTab: string;
  handleTabChange: (value: string) => void;
  isPPH: boolean;
};

export const FolderDetailsEC = ({
  isDraft,
  selectedDetailsTab,
  handleTabChange,
  isPPH,
}: FolderDetailsECProps) => {
  const { t } = useTranslation();

  return (
    <div className={cn("folder-details-wrapper-one-page", { "mx-auto": isPPH })}>
      {!isDraft ? (
        <Tabs className="" value={selectedDetailsTab} onValueChange={handleTabChange}>
          <TabsList className="folder-details-tab-list">
            <TabsTrigger value="elements" className="folder-details-tab">
              <ElementsIcon className="w-20 h-20" />
              <div className="folder-details-tab-title">
                {t("folder.details.tab.elements.title")}
              </div>
            </TabsTrigger>
            <TabsTrigger value="validation" className="folder-details-tab">
              <ValidationIcon className="w-20 h-20" />
              <div className="folder-details-tab-title">
                {t("folder.details.tab.validation.title")}
              </div>
            </TabsTrigger>
          </TabsList>
          <TabsContent value="elements">
            <FolderElements />
          </TabsContent>
          <TabsContent value="validation" className="folder-tab-content">
            <FolderCartographieTab />
          </TabsContent>
        </Tabs>
      ) : (
        <FolderElements />
      )}
    </div>
  );
};
